/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardVulnerabilityRegionValue {
    getFixupPrototypeFunction() { return SecurityDashboardVulnerabilityRegionValue.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardVulnerabilityRegionValue>): SecurityDashboardVulnerabilityRegionValue {
        let obj = Object.assign(new SecurityDashboardVulnerabilityRegionValue(), model);
        SecurityDashboardVulnerabilityRegionValue.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardVulnerabilityRegionValue>): SecurityDashboardVulnerabilityRegionValue {
        if (!model) return null;
        return SecurityDashboardVulnerabilityRegionValue.newInstance(<SecurityDashboardVulnerabilityRegionValue> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardVulnerabilityRegionValue) {
        if (!obj) return;

        models.SecurityDashboardVulnerabilityRegionValue.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardVulnerabilityRegionValue): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardVulnerabilityRegionValue.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.vulnerabilityCount === undefined) {
            this.vulnerabilityCount = 0;
        }
    }

    /**
     * Visibility of Region Name
     */
    region: string;

    /**
     * Visibility of Vulnerability Count by region
     */
    vulnerabilityCount: number;

}
